var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);
  if(selectedDate.getDate() === 26 && selectedMonth === 4 && selectedDate.getFullYear() === 2025) {  	    
    timepicker.set('max',[15, 0]);     
  }
  
  if(selectedDate.getDate() === 27 && selectedMonth === 5 && selectedDate.getFullYear() === 2025) {  	
    timepicker.set('min',[10, 0]); 
    timepicker.set('max',[19, 0]); 
    timepicker.set('interval', 60);
  }

  if(selectedDate.getDate() === 28 && selectedMonth === 5 && selectedDate.getFullYear() === 2025) {  	
    timepicker.set('min',[10, 0]); 
    timepicker.set('max',[19, 0]); 
    timepicker.set('interval', 60);
  }

  if(selectedDate.getDate() === 29 && selectedMonth === 5 && selectedDate.getFullYear() === 2025) {  	
    timepicker.set('min',[10, 0]); 
    timepicker.set('max',[19, 0]); 
    timepicker.set('interval', 60);
  }

  if(selectedDate.getDate() === 4 && selectedMonth === 6 && selectedDate.getFullYear() === 2025) {  	    
    timepicker.set('max',[15, 0]);     
  }

  if(selectedDate.getDate() === 1 && selectedMonth === 8 && selectedDate.getFullYear() === 2025) {  	    
    timepicker.set('max',[15, 0]);     
  }
}